<template>
  <section class="modal">
    <div class="box">
      <div class="header">
        <transition name="title">
          <div v-if="page === 1" key="enter">
            <img style="margin-top:5px; height: 30px;" src="/img/swiss.png" alt="Swiss Money" title="Swiss Money">
          </div>
          <div v-if="page === 2" key="register">
            <img style="margin-top:5px; height: 30px;" src="/img/swiss.png" alt="Swiss Money" title="Swiss Money">
          </div>
          <div v-if="page === 3 && newPassword" key="change-pass" class="title">Complete seu cadastro</div>
          <div v-if="page === 4" key="confirm-email" class="title">Confira seu e-mail</div>
          <div v-if="page === 5" key="login-change-pass" class="title">Alterar senha</div>
        </transition>
        <div @click="$store.commit('showLogin', false)" class="close"><i class="fas fa-times"></i></div>
      </div>
      <transition name="page">
        <!-- Entrar -->
        <div v-if="page === 1" key="page-1">
          <form @submit.prevent="signIn" class="form" style="margin-top:-25px;">
            <div v-show="false">
              <button @click="facebookSign" type="button" class="button-facebook">
                <i :class="loadingFacebook ? 'fas fa-spinner loading' : 'fab fa-facebook-f'"></i><span>Entrar com o Facebook</span>
              </button>
              <div v-if="error.includes('facebook')" class="hint hint-center" style="margin-bottom: 15px">Não foi possível entrar com o Facebook! Por favor tente novamente.</div>
              <button v-if="!android" @click="appleSign" type="button" class="button-apple">
                <i :class="loadingApple ? 'fas fa-spinner loading' : 'fab fa-apple'"></i><span>Sign in with Apple</span>
              </button>
              <div v-if="error.includes('apple')" class="hint hint-center">Não foi possível entrar com a Apple! Por favor tente novamente.</div>
              <div class="divider" data-text="OU"></div>
            </div>
            <label>E-mail</label>
            <input v-model="login" type="email" ref="login" id="login" placeholder="E-MAIL" :class="{ error : error.includes('login') || error.includes('invalid') }" style="text-transform: lowercase;"/>
            <div v-if="error.includes('login')" class="hint">você esqueceu o e-mail</div>
            <label>Senha</label>
            <input v-model="password" type="password" id="password" placeholder="SENHA" :class="{ error : error.includes('password') || error.includes('invalid') }"/>
            <div v-if="error.includes('password')" class="hint">senha inválida</div>
            <div v-if="error.includes('invalid')" class="hint">E-mail ou senha inválidos</div>
            <div v-if="error.includes('notValidated')" class="hint hint-center">Conta não ativada. Foi enviado um email em {{login}} para você ativar sua conta.</div>
            <div @click="forgotPass" class="forgot-pass">Esqueci minha senha</div>
            <button type="submit" class="button-save" style="margin-top: 20px">
              <i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-sign-in-alt'"></i><span>Entrar</span>
            </button>
            <div v-if="error.includes('blocked')" class="hint hint-center">Bloqueado pelas tentativas! Tente novamente mais tarde.</div>
            <div v-if="error.includes('internal')" class="hint hint-center">Alguma coisa deu errado! Tente novamente.</div>
            <div class="divider"></div>
            <button @click="page = 2" type="button" class="button-facebook" style="margin-top: 20px">
              <span>Não possui conta? Cadastrar</span>
            </button>
          </form>
        </div>
        <!-- Cadastrar -->
        <div v-if="page === 2" key="page-2">
          <form @submit.prevent="signOn" class="form">
            <label>Nome Completo</label>
            <input v-model="name" type="text" style="text-transform: uppercase;" placeholder="NOME" :class="{ error : error.includes('name') }"/>
            <div v-if="error.includes('name')" class="hint">Nome inválido! Precisa ser nome e sobrenome.</div>
            <label>Email</label>
            <input v-model="login" type="email" placeholder="E-MAIL" :class="{ error : error.includes('login') || error.includes('exists') }" style="text-transform: lowercase;"/>
            <div v-if="error.includes('login')" class="hint">você esqueceu o e-mail</div>
            <div v-if="error.includes('exists')" class="hint">Já existe um usuário cadastrado com esse e-mail</div>
            <label>Celular</label>
            <input v-model="phone" type="text" placeholder="CELULAR" :class="{ error : error.includes('phone') }"/>
            <div v-if="error.includes('phone')" class="hint">número de celular inválido</div>
            <label v-if="!gringo">CPF</label>
            <input v-if="!gringo" v-model="cpf" v-mask="['###.###.###-##']" type="text" placeholder="CPF" :class="{ error : error.includes('cpf') }"/>
            <div v-if="!gringo && error.includes('cpf')" class="hint">número de CPF inválido</div>
            <!--<label class="switch">
              <input v-model="gringo" type="checkbox">
              <span class="slider"></span>
              <span class="text" style="color:#282727;">Sou estrangeiro, não tenho CPF</span>
            </label>
            <label v-if="gringo">Outro documento Passaporte/ID</label>
            <input v-if="gringo" v-model="cpf" type="text" placeholder="Documento" :class="{ error : error.includes('cpf') }"/>
            <div v-if="gringo && error.includes('cpf')" class="hint">número de documento inválido</div>-->
            
            <label v-if="provider === 'local'">Senha</label>
            <input v-if="provider === 'local'" v-model="password" type="password" placeholder="SENHA" :class="{ error : error.includes('password') }"/>
            <div v-if="error.includes('password')" class="hint">você esqueceu a senha</div>
            <label v-if="provider === 'local'">Repita a senha</label>
            <input v-if="provider === 'local'" v-model="password2" type="password" placeholder="REPITA A SENHA" :class="{ error : error.includes('password2') }"/>
            <div v-if="error.includes('password2')" class="hint">Repita a senha corretamente</div>
            <label>Chegou até o Swiss Money através de:</label>
            <select v-model="fonte">
              <option value="NENHUM">Nenhum</option>
              <option value="TERCIO">Trader de Mesa Proprietária</option>
              <option value="REGIS">Pra cima Traders</option>
              <!--<option value="QE">QE</option>-->
              <option value="ANDERSON">Mesa Prop Americana/Trader Funding (Anderson)</option>
              <!--<option value="EMANUEL">EMANUEL</option> -->
              <option value="SWISS">Swiss Money Global</option>
              <option value="OUTRO">Outro</option>
            </select>
            <label v-if="fonte === 'OUTRO'">Por favor, digite aqui</label>
            <input v-if="fonte === 'OUTRO'" v-model="newfonte" type="text" placeholder="De onde veio?" style="text-transform: uppercase;"/>

            
            
            <div @click="page = 1" class="forgot-pass">Já tem cadastro? Clique aqui</div>
            <button type="submit" class="button-save" style="margin-top: 25px">
              <i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Finalizar</span>
            </button>
            <div v-if="error.includes('blocked')" class="hint hint-center">Bloqueado pelas tentativas! Tente novamente mais tarde.</div>
            <div v-if="error.includes('internal')" class="hint hint-center">Alguma coisa deu errado! Tente novamente.</div>
          </form>
        </div>
        <!-- Alterar Senha -->
        <div v-if="page === 3 || page === 5" key="page-3">
          <div class="change-pass-info">Acabamos de enviar o código de verificação para <span>{{ login }}</span></div>
          <form @submit.prevent class="form">
            <label>Código de Verificação</label>
            <input v-model="code" v-mask="'########'" type="text" placeholder="Código enviado por e-mail" :class="{ error : error.includes('code') }"/>
            <div v-if="error.includes('code')" class="hint">código inválido</div>
            <div @click="forgotPass" class="forgot-pass">Reenviar código de verificação</div>
            <label v-show="page === 3">Nome Completo</label>
            <input v-show="page === 3" v-model="name" type="text" style="text-transform: uppercase;" placeholder="NOME" :class="{ error : error.includes('name') }"/>
            <div v-show="page === 3" v-if="error.includes('name')" class="hint">Nome inválido! Precisa ser nome e sobrenome.</div>
            <label v-show="page === 3">Celular</label>
            <input v-show="page === 3" v-model="phone" type="text" placeholder="CELULAR" :class="{ error : error.includes('phone') }"/>
            <div v-show="page === 3" v-if="error.includes('phone')" class="hint">número de celular inválido</div>
            <label>Senha</label>
            <input v-model="password" type="password" placeholder="SENHA" :class="{ error : error.includes('password') }"/>
            <div v-if="error.includes('password')" class="hint">senha inválida</div>
            <label>Repita a senha</label>
            <input v-model="password2" type="password" placeholder="REPITA A SENHA" :class="{ error : error.includes('password2') }"/>
            <div v-if="error.includes('password2')" class="hint">Repita a senha corretamente</div>
            <button @click="changePass" class="button-save" style="margin-top: 25px">
              <i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>{{page === 3 ? 'Finalizar' : 'Atualizar'}}</span>
            </button>
            <div v-if="error.includes('blocked')" class="hint hint-center">Bloqueado pelas tentativas! Tente novamente mais tarde.</div>
            <div v-if="error.includes('internal')" class="hint hint-center">Alguma coisa deu errado! Tente novamente.</div>
          </form>
        </div>
        <div v-if="page === 4" key="page-3">
          <!--<div class="change-pass-info">Acesse seu e-mail <b>{{login}}</b> e clique no link de confirmação</div>
          <div class="change-pass-info">(O email de validação expira em 15 minutos)</div>-->
          <form @submit.prevent class="form">
            <button @click="closeModal" class="button-save" style="margin-top: 25px">
              <i class="fas"></i><span>Fechar</span>
            </button>
          </form>
        </div>
      </transition>
      <div></div>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { setToken, loadModule } from '../../util'
import {
  signin,
  signon,
  facebookSignin,
  facebookSignon,
  facebook,
  forgotPass,
  forgotPassChange,
  // savePlayerId,
  apple,
  appleSignin,
  appleSignon
} from '../api/auth'
// import { get as getCustomer } from '../api/customer'

export default {
  name: 'Login',
  data () {
    return {
      loading: false,
      loadingFacebook: false,
      page: 1,
      error: [],
      login: '',
      password: '',
      password2: null,
      name: null,
      phone: null,
      cpf: null,
      gringo: false,
      provider: 'local',
      providerToken: null,
      providerId: null,
      code: null,
      newPassword: false,
      loadingApple: false,
      android: process.env.CORDOVA_PLATFORM === 'android',
      fonte: null,
      newfonte: null
    }
  },
  watch: {
    page (newValue, oldValue) {
      this.error = ['']
      if (this.provider === 'local' && newValue !== 3 && newValue !== 5) {
        this.login = null
        this.name = null
        this.phone = null
        this.cpf = null
        this.gringo = false
        this.password = null
        this.password2 = null
        this.fonte = null
        this.newfonte = null
      }
    }
  },
  async mounted () {
    try {
      // New user
      if (this.$route.query.new) {
        this.page = 3
        this.login = this.$route.query.new
        this.newPassword = true
        await forgotPass(this.login, true)
      } else {
        setTimeout(() => this.$refs.login.focus(), 1000)
      }
    } catch (error) {
      const data = error.response ? error.response.data : {}
      // Validation error
      if (data.error === 'Validation error') {
        this.error = data.fields
      // Invalid login or password
      } else if (data.error === 'user_not_found') {
        this.error = ['invalid']
      } else if (data.error === 'user_not_validated') {
        this.error = ['notValidated']
      } else if (data.error === 'user_not_completed') {
        this.newPassword = true
        this.page = 3
        this.$message.success('Código de verificação enviado com sucesso', { duration: 3000 })
      } else if (data.error === 'user_created') {
        this.page = 1
        setTimeout(() => this.$refs.login.focus(), 1000)
        this.$router.push('/')
      } else if (data.error === 'Too many attemps') {
        this.error = ['blocked']
      } else {
        this.error = ['internal']
        logger.error(error, this)
      }
    }
  },
  methods: {
    closeModal () {
      this.$store.commit('showLogin', false)
    },
    async signIn () {
      if (this.loading) return false
      this.loading = true
      try {
        // Clean errors
        this.error = []
        // Sign in on frontend
        const data = await signin(this.login, this.password)
        // Set token on axios header
        setToken(data.token)
        if (data.user.role === 'admin') {
          // Start admin module
          this.$store.commit('showLogin', false)
          this.$router.push('/')
          this.$root.$destroy()
          loadModule('admin', data.user)
          document.body.style.backgroundColor = '#f2f2f2'
        } else if (data.user.role === 'business' || data.user.role === 'producer') {
          // Start business module
          this.$store.commit('showLogin', false)
          this.$router.push('/')
          this.$root.$destroy()
          loadModule('business', data.user, data.business)
        } else {
          // Start user module
          this.$store.commit('showLogin', false)
          this.$router.push('/')
          this.$root.$destroy()
          loadModule('user', data.user)
          /*
          // Save user on store
          this.$store.commit('user', data.user)
          document.body.style.backgroundColor = '#f2f2f2'
          // One Signal
          // await this.oneSignal()
          this.$analytics.event('signin')
          if (this.$store.state.redirect) {
            this.$router.push(this.$store.state.redirect)
            this.$store.commit('redirect', null)
          }
          */
        }
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        // Invalid login or password
        } else if (data.error === 'Invalid login or password') {
          this.error = ['invalid']
        // Too many attemps
        } else if (data.error === 'Email account not validated yet') {
          this.error = ['notValidated']
        } else if (data.error === 'Too many attemps') {
          this.error = ['blocked']
        } else {
          this.error = ['internal']
          logger.error(error, this)
        }
      }
      this.loading = false
    },
    async signOn () {
      if (this.loading) return false
      this.loading = true
      try {
        // Clean errors
        this.error = []
        let data = null
        // Sign On
        if (this.provider === 'facebook') {
          data = await facebookSignon(this.providerToken, this.providerId, this.login, this.phone, this.name)
        } else if (this.provider === 'apple') {
          data = await appleSignon(this.providerToken, this.login, this.phone, this.name)
        } else {
          if (this.newfonte) {
            this.fonte = this.newfonte
          }
          data = await signon(this.login, this.name, this.phone, this.cpf, this.password, this.password2, this.fonte, this.gringo)

          // Set token on axios header
          setToken(data.token)
          if (data.user.role === 'admin') {
            // Start admin module
            this.$store.commit('showLogin', false)
            document.body.style.backgroundColor = '#f2f2f2'
            this.$router.push('/')
            this.$root.$destroy()
            loadModule('admin', data.user)
          } else if (data.user.role === 'business' || data.user.role === 'producer') {
            // Start business module
            this.$store.commit('showLogin', false)
            this.$router.push('/')
            this.$root.$destroy()
            loadModule('business', data.user, data.business)
          } else {
            // Save user on store
            document.body.style.backgroundColor = '#f2f2f2'
            loadModule('user', data.user)
            this.$store.commit('user', data.user)
            this.$router.push('/')
            this.$root.$destroy()
            // One Signal
            // await this.oneSignal()
            this.$analytics.event('signon')
            if (this.$store.state.redirect) {
              this.$router.push(this.$store.state.redirect)
              this.$store.commit('redirect', null)
            }
            this.$store.commit('showLogin', false)
          }
        }

        /* if (this.provider === 'facebook' || this.provider === 'apple') {
          // Set token on axios header
          setToken(data.token)
          this.$store.commit('user', data.user)
          // One Signal
          await this.oneSignal()
          this.$analytics.event('signon')
          if (this.$store.state.redirect) {
            this.$router.push(this.$store.state.redirect)
            this.$store.commit('redirect', null)
          }
          this.$store.commit('showLogin', false)
        } else {
          this.page = 4
        } */
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        // User already exists
        } else if (data.error === 'User already exists') {
          this.error = ['exists']
        // Too many attemps
        } else if (data.error === 'Too many attemps') {
          this.error = ['blocked']
        } else {
          this.error = ['internal']
          logger.error(error, this)
        }
      }
      this.loading = false
    },
    async facebookSign () {
      if (this.loadingFacebook) return false
      this.loadingFacebook = true
      try {
        // Call Facebook API
        const { accessToken, id, email, name } = await facebook()
        const data = await facebookSignin(accessToken, id)
        // Sign in
        if (data.token && data.user) {
          setToken(data.token)
          if (data.user.role === 'admin') {
            // Start admin module
            this.$store.commit('showLogin', false)
            this.$router.push('/')
            this.$root.$destroy()
            loadModule('admin', data.user)
            document.body.style.backgroundColor = '#f2f2f2'
          } else if (data.user.role === 'business' || data.user.role === 'producer') {
            // Start business module
            this.$store.commit('showLogin', false)
            this.$router.push('/')
            this.$root.$destroy()
            loadModule('business', data.user, data.business)
          } else {
            // Save user on store
            this.$store.commit('user', data.user)
            // One Signal
            // await this.oneSignal()
            this.$analytics.event('signin', 'facebook')
            if (this.$store.state.redirect) {
              this.$router.push(this.$store.state.redirect)
              this.$store.commit('redirect', null)
            }
            this.$store.commit('showLogin', false)
            document.body.style.backgroundColor = '#f2f2f2'
          }
        // New user
        } else {
          this.provider = 'facebook'
          this.providerToken = accessToken
          this.providerId = id
          this.login = email
          this.name = name
          this.page = 2
        }
      } catch (error) {
        this.error = ['facebook']
        logger.error(error, this)
      }
      this.loadingFacebook = false
    },
    async forgotPass () {
      try {
        this.error = []
        await forgotPass(this.login)
        this.$message.success('Código de verificação enviado com sucesso', { duration: 3000 })
        if (this.$route.query.new) {
          this.page = 3
        } else {
          this.page = 5
        }
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        // Invalid login or password
        } else if (data.error === 'user_not_found') {
          this.error = ['invalid']
        } else if (data.error === 'user_not_validated') {
          this.error = ['notValidated']
        } else if (data.error === 'user_not_completed') {
          this.newPassword = true
          this.page = 3
          this.$message.success('Código de verificação enviado com sucesso', { duration: 3000 })
        } else if (data.error === 'Too many attemps') {
          this.error = ['blocked']
        } else {
          this.error = ['internal']
          logger.error(error, this)
        }
      }
    },
    async changePass () {
      if (this.loading) return false
      this.loading = true
      try {
        this.error = []
        const data = await forgotPassChange(this.login, this.code, this.password, this.password2, this.name, this.phone)
        // Set token on axios header
        setToken(data.token)
        if (data.user.role === 'admin') {
          // Start admin module
          this.$store.commit('showLogin', false)
          this.$router.push('/')
          this.$root.$destroy()
          loadModule('admin', data.user)
        } else if (data.user.role === 'business' || data.user.role === 'producer') {
          // Start business module
          this.$store.commit('showLogin', false)
          this.$router.push('/')
          this.$root.$destroy()
          loadModule('business', data.user, data.business)
        } else {
          // Save user on store
          this.$store.commit('user', data.user)
          // One Signal
          await this.oneSignal()
          this.$analytics.event('signin')
          if (this.$store.state.redirect) {
            this.$router.push(this.$store.state.redirect)
            this.$store.commit('redirect', null)
          }
          if (this.$route.query.new) {
            this.$router.push('/')
          }
          this.$store.commit('showLogin', false)
        }
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        // Too many attemps
        } else if (data.error === 'Too many attemps') {
          this.error = ['blocked']
        } else {
          this.error = ['internal']
          logger.error(error, this)
        }
      }
      this.loading = false
    },
    async oneSignal () {
      if (process.env.NODE_ENV !== 'production') return false
      /*
      // CORDOVA
      if (process.env.CORDOVA_PLATFORM) {
        window.plugins.OneSignal.getPermissionSubscriptionState(async (status) => {
          if (status.subscriptionStatus.subscribed) {
            await savePlayerId(status.subscriptionStatus.userId)
            const customer = await getCustomer()
            window.plugins.OneSignal.setExternalUserId(customer.userId)
            window.plugins.OneSignal.sendTags({
              user_id: customer.userId,
              user_type: 'user',
              real_name: customer.name,
              first_name: customer.name.split(' ')[0]
            })
            window.plugins.OneSignal.setEmail(customer.login)
          }
        })
      // WEB
      } else {
        const pushEnabled = window.OneSignal ? await window.OneSignal.isPushNotificationsEnabled() : null
        if (pushEnabled) {
          const playerId = await window.OneSignal.getUserId()
          await savePlayerId(playerId)
          const customer = await getCustomer()
          window.OneSignal.setExternalUserId(customer.userId)
          window.OneSignal.push(() => {
            window.OneSignal.sendTags({
              user_id: customer.userId,
              user_type: 'user',
              real_name: customer.name,
              first_name: customer.name.split(' ')[0]
            })
          })
          window.OneSignal.setEmail(customer.login)
        }
      }
      */
    },
    async appleSign () {
      if (this.loadingApple) return false
      this.loadingApple = true
      try {
        // Call Apple Sing In
        const appleCredential = await apple()
        const data = await appleSignin(appleCredential.token)
        // Sign in
        if (data.token && data.user) {
          setToken(data.token)
          if (data.user.role === 'admin') {
            // Start admin module
            this.$store.commit('showLogin', false)
            this.$router.push('/')
            this.$root.$destroy()
            loadModule('admin', data.user)
          } else if (data.user.role === 'business' || data.user.role === 'producer') {
            // Start business module
            this.$store.commit('showLogin', false)
            this.$router.push('/')
            this.$root.$destroy()
            loadModule('business', data.user, data.business)
          } else {
            // Save user on store
            this.$store.commit('user', data.user)
            // One Signal
            await this.oneSignal()
            this.$analytics.event('signin', 'apple')
            if (this.$store.state.redirect) {
              this.$router.push(this.$store.state.redirect)
              this.$store.commit('redirect', null)
            }
            this.$store.commit('showLogin', false)
          }
        // New user
        } else {
          this.provider = 'apple'
          this.providerToken = appleCredential.token
          this.login = data.email
          this.name = appleCredential.name
          this.page = 2
        }
      } catch (error) {
        this.error = ['apple']
        logger.error(error, this)
      }
      this.loadingApple = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.modal .box {
  max-height: 95%;
}

.hint-center {
  text-align: center;
  margin-top: 10px !important;
}

.box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.button-facebook {
  color: #fff;
  border: none;
  border-radius: 100px;
  box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  background-image: linear-gradient(to bottom right, #2f55a4, #4e71ba);
  font-size: 1.1em;
  font-weight: 400;
  width: auto;
  height: 40px;
  padding: 0 15px;
  margin-bottom: 10px;
  cursor: pointer;
  &:focus {
    outline: 0;
  }
  i {
    margin-right: 10px;
  }
  .loading {
    color: #fff;
  }
}

.button-apple {
  color: #fff !important;
  border: none;
  border-radius: 100px;
  box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
  background-color: #000;
  font-size: 1.1em;
  font-weight: 400;
  width: auto;
  height: 40px;
  padding: 0 15px;
  cursor: pointer;
  &:focus {
    outline: 0;
  }
  i {
    margin-right: 10px;
  }
  .loading {
    color: #fff;
  }
}

.divider {
  position: relative;
  width: 100%;
  margin-top: 30px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  &::after {
    content: attr(data-text);
    background-color: #fff;
    color: #aaa;
    font-size: 0.9em;
    padding: 0 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.forgot-pass {
  text-transform: uppercase;
  color: #f4f6fa;
  font-size: 0.9em;
  margin-top: 15px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

.logo-signin {
  text-align: center;
  margin: 0 0 25px;
  svg {
    color: $primary-color;
    height: 50px;
  }
}

.box-icon {
  color: $primary-color;
  font-size: 80px;
  padding: 0 0 25px;
}

.change-pass-info {
  color: #555;
  font-size: 1.1em;
  padding: 15px 15px;
  text-align: center;
  span {
    display: block;
    color: $primary-color;
  }
}

// Desktop
@media screen and (min-width: $desktop-width) {
  .logo-signin, .box-icon {
    display: none;
  }
}
</style>

<style lang="scss">
.logo-signin {
  svg {
    .ticket-text {
      transform: translateX(-30px) !important;
    }
  }
}
</style>
